<div class="w-full flex justify-center my-5">
  <div class="max-w-2xl flex flex-col space-y-5">
    
    <h2 class="text-lg font-bold">Accordion</h2>
    <div hlmAccordion>
      <div hlmAccordionItem>
        <button hlmAccordionTrigger>
          Is it accessible?
          <ng-icon name="lucideChevronDown" hlm hlmAccIcon />
        </button>
        <hlm-accordion-content>Yes. It adheres to the WAI-ARIA design pattern.</hlm-accordion-content>
      </div>
      
      <div hlmAccordionItem>
        <button hlmAccordionTrigger>
          Is it styled?
          <ng-icon name="lucideChevronDown" hlm hlmAccIcon />
        </button>
        <hlm-accordion-content>
          Yes. It comes with default styles that match the other components' aesthetics.
        </hlm-accordion-content>
      </div>
      
      <div hlmAccordionItem>
        <button hlmAccordionTrigger>
          Is it animated?
          <ng-icon name="lucideChevronDown" hlm hlmAccIcon />
        </button>
        <hlm-accordion-content>
          Yes. It's animated by default, but you can disable it if you prefer.
        </hlm-accordion-content>
      </div>
    </div>
    
    <h2 class="text-lg font-bold">Alert</h2>
    <div hlmAlert>
      <ng-icon hlm hlmAlertIcon name="lucideBox" />
      <h4 hlmAlertTitle>Introducing spartan/ui!</h4>
      <p hlmAlertDesc>
        spartan/ui is made up of unstyled UI providers, the spartan/ui/brain.<br />
        On top we add spartan/ui/helm(et) with shadcn-like styles.
      </p>
    </div>
    
    <h2 class="text-lg font-bold">Alert Dialog</h2>
    <hlm-alert-dialog>
      <button id="edit-profile" variant="outline" brnAlertDialogTrigger hlmBtn>Delete Account</button>
      <hlm-alert-dialog-content *brnAlertDialogContent="let ctx">
        <hlm-alert-dialog-header>
          <h3 hlmAlertDialogTitle>Are you absolutely sure?</h3>
          <p hlmAlertDialogDescription>
            This action cannot be undone. This will permanently delete your account and remove your data from our
            servers.
          </p>
        </hlm-alert-dialog-header>
        <hlm-alert-dialog-footer>
          <button hlmAlertDialogCancel (click)="ctx.close()">Cancel</button>
          <button hlmAlertDialogAction (click)="ctx.close()">Delete account</button>
        </hlm-alert-dialog-footer>
      </hlm-alert-dialog-content>
    </hlm-alert-dialog>
    
    <h2 class="text-lg font-bold">Avatar</h2>
    <hlm-avatar variant="large">
      <img src="/assets/avatar.png" alt="spartan logo. Resembling a spartanic shield" hlmAvatarImage />
      <span class="bg-primary text-white" hlmAvatarFallback>RG</span>
    </hlm-avatar>
    
    <h2 class="text-lg font-bold">Badge</h2>
    <div>
      <span hlmBadge>This is a badge.</span>
      <br>
      <span hlmBadge>It can be short, it can be long</span>
    </div>

    <h2 class="text-lg font-bold">Breadcrumbs</h2>
    <nav hlmBreadcrumb>
      <ol hlmBreadcrumbList>
        <li hlmBreadcrumbItem>
          <a hlmBreadcrumbLink link="/home">Home</a>
        </li>
        <li hlmBreadcrumbSeparator></li>
        <li hlmBreadcrumbItem>
          <hlm-breadcrumb-ellipsis class="h-4 w-4" [brnMenuTriggerFor]="breadcrumbDropdown" />
          <ng-template #breadcrumbDropdown>
            <hlm-menu>
              <button hlmMenuItem id="document">
                <span>Documentation</span>
              </button>
              <button hlmMenuItem id="themes">
                <span>Themes</span>
              </button>
              <button hlmMenuItem id="github">
                <span>Github</span>
              </button>
            </hlm-menu>
          </ng-template>
        </li>
        <li hlmBreadcrumbSeparator></li>
        <li hlmBreadcrumbItem>
          <a hlmBreadcrumbLink link="/components">Components</a>
        </li>
        <li hlmBreadcrumbSeparator></li>
        <li hlmBreadcrumbItem>
          <span hlmBreadcrumbPage>Breadcrumb</span>
        </li>
      </ol>
    </nav>

    <h2 class="text-lg font-bold">Button</h2>
    <div class="grid grid-cols-2 gap-2">
      <button hlmBtn>Primary button</button>
      <button hlmBtn variant="secondary">Secondary button</button>
      <button hlmBtn variant="outline">Outline</button>
      <button hlmBtn variant="destructive">Destructive</button>
      <button hlmBtn variant="link">Link</button>
      <button hlmBtn variant="ghost">Ghost</button>
    </div>

    <h2 class="text-lg font-bold">Calendar</h2>
    <div class="grid grid-cols-2 gap-2">
      <hlm-calendar/>
    </div>

    <h2 class="text-lg font-bold">Card</h2>
    <section class="w-80" hlmCard>
      <div hlmCardHeader>
        <h3 hlmCardTitle>Create new project</h3>
        <p hlmCardDescription>Deploy your new project in one-click.</p>
      </div>
      <p hlmCardContent>
        <label class="block" hlmLabel>
          Name
          <input class="mt-1.5 w-full" placeholder="Name of your project" hlmInput />
        </label>
      </p>
      <div hlmCardFooter class="justify-between">
        <button hlmBtn variant="ghost">Cancel</button>
        <button hlmBtn>Create</button>
      </div>
    </section>

    <h2 class="text-lg font-bold">Carousel</h2>
    <div class="flex items-center justify-center w-full p-4">
      <hlm-carousel class="w-full max-w-xs">
        <hlm-carousel-content>
        @for (item of [1,2,3,4,5]; track item) {
          <hlm-carousel-item>
            <div class="p-1">
              <section hlmCard>
                <p hlmCardContent class="flex items-center justify-center p-6 aspect-square">
                  <span class="text-4xl font-semibold">{{ item }}</span>
                </p>
              </section>
            </div>
          </hlm-carousel-item>
        }
        </hlm-carousel-content>
        <button hlm-carousel-previous></button>
        <button hlm-carousel-next></button>
      </hlm-carousel>
    </div>

    <h2 class="text-lg font-bold">Checkbox</h2>
    <label class="flex items-center" hlmLabel>
      <hlm-checkbox class="mr-2" />
      Accept terms and conditions
    </label>

    <h2 class="text-lg font-bold">Combobox</h2>
    <brn-popover sideOffset="5">
      <button class="w-[200px] justify-between" id="edit-profile" variant="outline" brnPopoverTrigger hlmBtn>
        {{ 'Select framework...' }}
        <ng-icon hlm size="sm" name="lucideChevronsUpDown" />
      </button>
      <hlm-command *brnPopoverContent="let ctx" hlmPopoverContent class="p-0 w-[200px]">
          <hlm-command-search>
          <ng-icon hlm name="lucideSearch" />
          <input placeholder="Search framework..." hlm-command-search-input />
        </hlm-command-search>
        <div *brnCommandEmpty hlmCommandEmpty>No results found.</div>
        <hlm-command-list>
          <hlm-command-group>
            <button
              *ngFor="let framework of ['Angular', 'React', 'Vue', 'Svelte']"
              hlm-command-item
              [value]="framework.value"
            >
              <ng-icon hlm
                name="lucideCheck"
                hlmCommandIcon
              />
              {{ framework }}
            </button>
          </hlm-command-group>
        </hlm-command-list>
      </hlm-command>
    </brn-popover>

    <h2 class="text-lg font-bold">Command Menu</h2>
    <hlm-command class="w-full max-h-[320px]">
      <hlm-command-search>
        <ng-icon hlm name="lucideSearch" class="inline-flex" />
    
        <input
          type="text"
          hlm-command-search-input
          placeholder="Type a command or search..."
        />
      </hlm-command-search>
    
      <hlm-command-list>
        <hlm-command-group>
          <hlm-command-group-label>Suggestions</hlm-command-group-label>
    
          <button hlm-command-item value="Calendar">
            <ng-icon hlm name="lucideCalendar" hlmCommandIcon />
            Calendar
          </button>
          <button hlm-command-item value="Search Emoji">
            <ng-icon hlm name="lucideSmile" hlmCommandIcon />
            Search Emoji
          </button>
          <button hlm-command-item value="Calculator">
            <ng-icon hlm name="lucidePlus" hlmCommandIcon />
            Calculator
          </button>
        </hlm-command-group>
    
        <hlm-command-separator />
    
        <hlm-command-group>
          <hlm-command-group-label>Settings</hlm-command-group-label>
    
          <button hlm-command-item value="Profile">
            <ng-icon hlm name="lucideUser" hlmCommandIcon />
            Profile
            <hlm-command-shortcut>⌘P</hlm-command-shortcut>
          </button>
          <button hlm-command-item value="Billing">
            <ng-icon hlm name="lucideWallet" hlmCommandIcon />
            Billing
            <hlm-command-shortcut>⌘B</hlm-command-shortcut>
          </button>
          <button hlm-command-item value="Settings">
            <ng-icon hlm name="lucideCog" hlmCommandIcon />
            Settings
            <hlm-command-shortcut>⌘S</hlm-command-shortcut>
          </button>
        </hlm-command-group>
      </hlm-command-list>
    
      <!-- Empty state -->
      <div *brnCommandEmpty hlmCommandEmpty>No results found.</div>
    </hlm-command>

    <h2 class="text-lg font-bold">Context Menu</h2>
    <div
      [brnCtxMenuTriggerFor]="menu"
      class="border-border flex h-[150px] items-center justify-center rounded-md border border-dashed text-sm"
      >
      Right click here
    </div>
  
    <ng-template #menu>
      <hlm-menu class="w-64">
        <hlm-menu-group>
          <button inset hlmMenuItem>
            Back
            <hlm-menu-shortcut>⌘[</hlm-menu-shortcut>
          </button>

          <button disabled inset hlmMenuItem>
            Forward
            <hlm-menu-shortcut>⌘]</hlm-menu-shortcut>
          </button>

          <button disabled inset hlmMenuItem>
            Reload
            <hlm-menu-shortcut>⌘R</hlm-menu-shortcut>
          </button>

          <button inset hlmMenuItem [brnMenuTriggerFor]="moreTools">
            More Tools
            <hlm-menu-item-sub-indicator />
          </button>
        </hlm-menu-group>

        <hlm-menu-separator />

        <hlm-menu-group>
          <button hlmMenuItemCheckbox checked>
            <hlm-menu-item-check />
            Show Booksmarks Bar
            <hlm-menu-shortcut>⌘⇧B</hlm-menu-shortcut>
          </button>
          <button hlmMenuItemCheckbox>
            <hlm-menu-item-check />
            Show full URLs
          </button>
        </hlm-menu-group>

        <hlm-menu-separator />
        <hlm-menu-label inset>People</hlm-menu-label>
        <hlm-menu-separator />
        <hlm-menu-group>
          <button hlmMenuItemRadio checked>
            <hlm-menu-item-radio />
            Pedro Duarte
          </button>
          <button hlmMenuItemRadio>
            <hlm-menu-item-radio />
            Colm Tuite
          </button>
        </hlm-menu-group>
      </hlm-menu>
    </ng-template>
  
    <ng-template #moreTools>
      <hlm-sub-menu class="w-48">
        <button hlmMenuItem>
          Save Page as...
          <hlm-menu-shortcut>⇧⌘S</hlm-menu-shortcut>
        </button>
        <button hlmMenuItem>Create Shortcut...</button>
        <button hlmMenuItem>Name Window...</button>
        <hlm-menu-separator />
        <button hlmMenuItem>Developer Tools</button>
      </hlm-sub-menu>
    </ng-template>
  
    <h2 class="text-lg font-bold">Data Table</h2>
    <div class="flex flex-col justify-between gap-4 sm:flex-row">
      <input
        hlmInput
        class="w-full md:w-80"
        placeholder="Filter emails..."
        [ngModel]="_emailFilter()"
        (ngModelChange)="_rawFilterInput.set($event)"
      />

      <button hlmBtn variant="outline" align="end" [brnMenuTriggerFor]="menu">
        Columns
        <ng-icon hlm name="lucideChevronDown" class="ml-2" size="sm" />
      </button>
      <ng-template #menu>
        <hlm-menu class="w-32">
          @for (column of _brnColumnManager.allColumns; track column.name) {
            <button
              hlmMenuItemCheckbox
              [disabled]="_brnColumnManager.isColumnDisabled(column.name)"
              [checked]="_brnColumnManager.isColumnVisible(column.name)"
              (triggered)="_brnColumnManager.toggleVisibility(column.name)"
            >
              <hlm-menu-item-check />
              <span>{{ column.label }}</span>
            </button>
          }
        </hlm-menu>
      </ng-template>
    </div>

    <brn-table
      hlm
      stickyHeader
      class="border-border mt-4 block h-[335px] overflow-auto rounded-md border"
      [dataSource]="_filteredSortedPaginatedPayments()"
      [displayedColumns]="_allDisplayedColumns()"
      [trackBy]="_trackBy"
    >
      <brn-column-def name="select" class="w-12">
        <hlm-th *brnHeaderDef>
          <hlm-checkbox [checked]="_checkboxState()" (changed)="handleHeaderCheckboxChange()" />
        </hlm-th>
        <hlm-td *brnCellDef="let element">
          <hlm-checkbox [checked]="_isPaymentSelected(element)" (changed)="togglePayment(element)" />
        </hlm-td>
      </brn-column-def>
      <brn-column-def name="status" class="w-32 sm:w-40">
        <hlm-th truncate *brnHeaderDef>Status</hlm-th>
        <hlm-td truncate *brnCellDef="let element">
          {{ element.status | titlecase }}
        </hlm-td>
      </brn-column-def>
      <brn-column-def name="email" class="w-60 lg:flex-1">
        <hlm-th *brnHeaderDef>
          <button hlmBtn size="sm" variant="ghost" (click)="handleEmailSortChange()">
            Email
            <ng-icon hlm class="ml-3" size="sm" name="lucideArrowUpDown" />
          </button>
        </hlm-th>
        <hlm-td truncate *brnCellDef="let element">
          {{ element.email }}
        </hlm-td>
      </brn-column-def>
      <brn-column-def name="amount" class="justify-end w-20">
        <hlm-th *brnHeaderDef>Amount</hlm-th>
        <hlm-td class="font-medium tabular-nums" *brnCellDef="let element">
          $ {{ element.amount | number: '1.2-2'}}
        </hlm-td>
      </brn-column-def>
      <brn-column-def name="actions" class="w-16">
        <hlm-th *brnHeaderDef></hlm-th>
        <hlm-td *brnCellDef="let element">
          <button hlmBtn variant="ghost" class="h-6 w-6 p-0.5" align="end" [brnMenuTriggerFor]="menu">
            <ng-icon hlm size="sm" name="lucideEllipsis" />
          </button>

          <ng-template #menu>
            <hlm-menu>
              <hlm-menu-label>Actions</hlm-menu-label>
              <hlm-menu-separator />
              <hlm-menu-group>
                <button hlmMenuItem>Copy payment ID</button>
              </hlm-menu-group>
              <hlm-menu-separator />
              <hlm-menu-group>
                <button hlmMenuItem>View customer</button>
                <button hlmMenuItem>View payment details</button>
              </hlm-menu-group>
            </hlm-menu>
          </ng-template>
        </hlm-td>
      </brn-column-def>
      <div class="flex items-center justify-center p-20 text-muted-foreground" brnNoDataRow>No data</div>
    </brn-table>
    <div
      class="flex flex-col justify-between mt-4 sm:flex-row sm:items-center"
      *brnPaginator="let ctx; totalElements: _totalElements(); pageSize: _pageSize(); onStateChange: _onStateChange"
    >
      <span class="text-sm text-muted-foreground text-sm">{{ _selected().length }} of {{ _totalElements() }} row(s) selected</span>
      <div class="flex mt-2 sm:mt-0">
        <brn-select class="inline-block" placeholder="{{ _availablePageSizes[0] }}" [(ngModel)]="_pageSize">
          <hlm-select-trigger class="inline-flex mr-1 w-15 h-9">
            <hlm-select-value />
          </hlm-select-trigger>
          <hlm-select-content>
            @for (size of _availablePageSizes; track size) {
              <hlm-option [value]="size">
                {{ size === 10000 ? 'All' : size }}
              </hlm-option>
            }
          </hlm-select-content>
        </brn-select>

        <div class="flex space-x-1">
          <button size="sm" variant="outline" hlmBtn [disabled]="!ctx.decrementable()" (click)="ctx.decrement()">
            Previous
          </button>
          <button size="sm" variant="outline" hlmBtn [disabled]="!ctx.incrementable()" (click)="ctx.increment()">
            Next
          </button>
        </div>
      </div>
    </div>

    <h2 class="text-lg font-bold">Date picker</h2>
    <hlm-date-picker>
      <span>Pick a date</span>
    </hlm-date-picker>

    <h2 class="text-lg font-bold">Form Field</h2>
    <hlm-form-field>
      <input class="w-80" hlmInput type="email" placeholder="Email" />
      <hlm-hint>This is your email address.</hlm-hint>
    </hlm-form-field>

    <h2 class="text-lg font-bold">Hover card</h2>
    <brn-hover-card>
      <button hlmBtn variant="link" brnHoverCardTrigger>&#64;analogjs</button>
      <hlm-hover-card-content *brnHoverCardContent class="w-80">
        <div class="flex justify-between space-x-4">
          <hlm-avatar variant="small" id="avatar-small">
            <img src="https://analogjs.org/img/logos/analog-logo.svg" alt="AnalogLogo" hlmAvatarImage />
            <span class="text-red-800 bg-red-600" hlmAvatarFallback>AN</span>
          </hlm-avatar>
          <div class="space-y-1">
            <h4 class="text-sm font-semibold">&#64;analogjs</h4>
            <p class="text-sm">The Angular meta-framework – build Angular applications faster.</p>
            <div class="flex items-center pt-2">
              <ng-icon hlm size="sm" name="lucideCalendar" class="mr-2 opacity-70" />
              <span class="text-xs text-muted-foreground">Joined December 2021</span>
            </div>
          </div>
        </div>
      </hlm-hover-card-content>
    </brn-hover-card>

    <h2 class="text-lg font-bold">OTP Input</h2>
    <brn-input-otp hlm maxLength="6" inputClass="disabled:cursor-not-allowed">
      <div hlmInputOtpGroup>
        <hlm-input-otp-slot index="0" />
        <hlm-input-otp-slot index="1" />
        <hlm-input-otp-slot index="2" />
      </div>
      <hlm-input-otp-separator />
      <div hlmInputOtpGroup>
        <hlm-input-otp-slot index="3" />
        <hlm-input-otp-slot index="4" />
        <hlm-input-otp-slot index="5" />
      </div>
    </brn-input-otp>

    <h2 class="text-lg font-bold">Menubar</h2>
    <hlm-menu-bar class="w-fit">
      <button hlmMenuBarItem [brnMenuTriggerFor]="file">File</button>
      <button hlmMenuBarItem [brnMenuTriggerFor]="edit">Edit</button>
      <button hlmMenuBarItem [brnMenuTriggerFor]="view">View</button>
      <button hlmMenuBarItem [brnMenuTriggerFor]="profiles">Profiles</button>
    </hlm-menu-bar>

    <ng-template #file>
      <hlm-menu variant="menubar" class="w-48">
        <hlm-menu-group>
          <button hlmMenuItem>
            New Tab
            <hlm-menu-shortcut>⌘T</hlm-menu-shortcut>
          </button>
          <button hlmMenuItem>
            New Window
            <hlm-menu-shortcut>⌘N</hlm-menu-shortcut>
          </button>
          <button hlmMenuItem disabled>New Incognito Window</button>
        </hlm-menu-group>

        <hlm-menu-separator />

        <button hlmMenuItem [brnMenuTriggerFor]="share">
          Share
          <hlm-menu-item-sub-indicator />
        </button>

        <hlm-menu-separator />

        <button hlmMenuItem>
          Print...
          <hlm-menu-shortcut>⌘P</hlm-menu-shortcut>
        </button>
      </hlm-menu>
    </ng-template>
    <ng-template #share>
      <hlm-sub-menu>
        <button hlmMenuItem>Email link</button>
        <button hlmMenuItem>Messages</button>
        <button hlmMenuItem>Notes</button>
      </hlm-sub-menu>
    </ng-template>

    <ng-template #edit>
      <hlm-menu variant="menubar" class="w-48">
        <hlm-menu-group>
          <button hlmMenuItem>
            Undo
            <hlm-menu-shortcut>⌘Z</hlm-menu-shortcut>
          </button>
          <button hlmMenuItem>
            Redo
            <hlm-menu-shortcut>⇧⌘Z</hlm-menu-shortcut>
          </button>
        </hlm-menu-group>

        <hlm-menu-separator />

        <button hlmMenuItem [brnMenuTriggerFor]="find">
          Share
          <hlm-menu-item-sub-indicator />
        </button>

        <hlm-menu-separator />

        <button hlmMenuItem>Cut</button>
        <button hlmMenuItem>Copy</button>
        <button hlmMenuItem>Paste</button>
      </hlm-menu>
    </ng-template>
    <ng-template #find>
      <hlm-sub-menu>
        <button hlmMenuItem>Search the web</button>
        <hlm-menu-separator />
        <button hlmMenuItem>Find...</button>
        <button hlmMenuItem>Find Next</button>
        <button hlmMenuItem>Find Previous</button>
      </hlm-sub-menu>
    </ng-template>

    <ng-template #view>
      <hlm-menu variant="menubar">
        <button hlmMenuItemCheckbox>
          <hlm-menu-item-check />
          Always Show Bookmarks Bar
        </button>
        <button hlmMenuItemCheckbox checked>
          <hlm-menu-item-check />
          Always Show Full URLs
        </button>
        <hlm-menu-separator />
        <button inset hlmMenuItem>
          Reload
          <hlm-menu-shortcut>⌘R</hlm-menu-shortcut>
        </button>
        <button inset disabled hlmMenuItem>
          Force Reload
          <hlm-menu-shortcut>⇧⌘R</hlm-menu-shortcut>
        </button>
        <hlm-menu-separator />
        <button inset hlmMenuItem>Toggle Fullscreen</button>
        <hlm-menu-separator />
        <button inset hlmMenuItem>Hide Sidebar</button>
      </hlm-menu>
    </ng-template>

    <ng-template #profiles>
      <hlm-menu variant="menubar" class="w-48">
        <button hlmMenuItemRadio>
          <hlm-menu-item-radio />
          Andy
        </button>
        <button hlmMenuItemRadio checked>
          <hlm-menu-item-radio />
          Benoit
        </button>
        <button hlmMenuItemRadio>
          <hlm-menu-item-radio />
          Lewis
        </button>
        <hlm-menu-separator />
        <button inset hlmMenuItem>Edit...</button>
        <hlm-menu-separator />
        <button inset hlmMenuItem>Add Profile...</button>
      </hlm-menu>
    </ng-template>

    <h2 class="font-bold text-lg">Pagination</h2>
    <nav hlmPagination class="w-full">
      <ul hlmPaginationContent>
          <li hlmPaginationItem>
              <hlm-pagination-previous link="/components/menubar" />
          </li>
          <li hlmPaginationItem>
              <a hlmPaginationLink link="#">1</a>
          </li>
          <li hlmPaginationItem>
              <a hlmPaginationLink link="#" isActive>2</a>
          </li>
          <li hlmPaginationItem>
              <a hlmPaginationLink link="#">3</a>
          </li>
          <li hlmPaginationItem>
              <hlm-pagination-ellipsis />
          </li>
          <li hlmPaginationItem>
              <hlm-pagination-next link="/components/popover" />
          </li>
      </ul>
    </nav>

    <h2 class="font-bold text-lg">Select</h2>
    <brn-select class="inline-block" placeholder="Select an option">
      <hlm-select-trigger class="w-56">
        <hlm-select-value />
      </hlm-select-trigger>
      <hlm-select-content>
        <hlm-option value="Refresh">Refresh</hlm-option>
        <hlm-option value="Settings">Settings</hlm-option>
        <hlm-option value="Help">Help</hlm-option>
        <hlm-option value="Signout">Sign out</hlm-option>
      </hlm-select-content>
    </brn-select>

    <h2 class="font-bold text-lg">Sheet</h2>
    <hlm-sheet side="right">
      <button id="edit-profile" variant="outline" brnSheetTrigger hlmBtn>Edit Profile</button>
      <hlm-sheet-content *brnSheetContent="let ctx">
        <hlm-sheet-header>
          <h3 hlmSheetTitle>Edit Profile</h3>
          <p hlmSheetDescription>Make changes to your profile here. Click save when you're done.</p>
        </hlm-sheet-header>
        <div class="py-4 grid gap-4">
          <div class="items-center grid grid-cols-4 gap-4">
            <label hlmLabel for="name" class="text-right">Name</label>
            <input hlmInput id="name" value="Pedro Duarte" class="col-span-3" />
          </div>
          <div class="items-center grid grid-cols-4 gap-4">
            <label hlmLabel for="username" class="text-right">Username</label>
            <input hlmInput id="username" value="@peduarte" class="col-span-3" />
          </div>
        </div>
        <hlm-sheet-footer>
          <button hlmBtn type="submit">Save Changes</button>
        </hlm-sheet-footer>
      </hlm-sheet-content>
    </hlm-sheet>

    <h2 class="text-lg font-bold">Slider</h2>
    <hlm-slider />

    <h2 class="text-lg font-bold">Toast</h2>
    <hlm-toaster />
    <button hlmBtn (click)="showToast()">Show Toast</button>

    <h2 class="text-lg font-bold">Switch</h2>
    <label class="flex items-center" hlmLabel>
      <hlm-switch class="mr-2" />
      Airplane mode
    </label>
    
  </div>
</div>
